import React from 'react';
import Modal from 'react-bootstrap/Modal';
import CustomButton from '../customButton';
import styles from './styles.module.css';

function CustomAlert({ show, handleClose, message, buttonLabel, buttonClassName, redirectUser, modalTitle }) {
  
    const handleButtonClick = () => {
        handleClose();
        if(redirectUser) {
            redirectUser();
        }
    }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <CustomButton onClick={handleButtonClick}
          className={styles.closeButton}
          label={buttonLabel}
        />
      </Modal.Footer>
    </Modal>
  );
}

export default CustomAlert;